import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global error handler to prevent silent white screens on Safari/iPad
window.addEventListener('error', (event) => {
  // Suppress benign ResizeObserver loop warnings emitted by Radix/cmdk popovers in dev
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    return;
  }
  console.error('Global error:', event.error);
});
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
